module.exports = {"npc_death":"Morte del nemico","player_death":"Morte del giocatore","player_spell":"Incantesimi di Brama di Sangue"};